import React from 'react';
import IconActionButton from './IconActionButton';

export default function RowActions({ actions = [] }) {
  return (
    <div className="wt-row-actions">
      {actions.map((action) => (
        <IconActionButton key={action.id || action.label} {...action} />
      ))}
    </div>
  );
}
